'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { Home, Users, Activity, MessageCircle, FileText } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Overview', path: '/dashboard', icon: Home },
  { label: 'Family Hub', path: '/family-coordination-hub', icon: Users },
  { label: 'Kin Check', path: '/check-ins', icon: Activity },
  { label: 'Kin Chat', path: '/benefits', icon: MessageCircle },
  { label: 'Records', path: '/medication-manager', icon: FileText },
];

export default function MobileBottomNav() {
  const pathname = usePathname();

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 safe-area-bottom"
      style={{
        height: 72,
        background: 'rgba(245, 241, 235, 0.82)',
        backdropFilter: 'blur(24px) saturate(200%)',
        WebkitBackdropFilter: 'blur(24px) saturate(200%)',
        borderTop: '1px solid rgba(214, 171, 71, 0.2)',
        boxShadow: '0 -8px 32px rgba(0,0,0,0.08)',
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
      }}
    >
      <div className="flex items-center justify-around h-full px-2">
        {NAV_ITEMS.map((item) => {
          const isActive = pathname === item.path;
          const Icon = item.icon;
          return (
            <Link
              key={item.path}
              href={item.path}
              className="flex flex-col items-center justify-center gap-1 flex-1 min-w-0 py-2 rounded-xl transition-all duration-200 active:scale-95 active:bg-black/5"
              style={{
                color: isActive ? '#D6AB47' : '#9B9590',
              }}
            >
              <Icon
                size={24}
                strokeWidth={isActive ? 2.25 : 2}
                className="shrink-0"
              />
              <span
                className="text-[10px] font-medium truncate w-full text-center"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
